import { DialogOptions } from '../../../models/modal.model'
import {
  GenericNotificationCode,
  NotificationOptions,
  parseGenericNotification,
} from '../../../models/notification.model'
import { Manufacturer } from '../models/manufacturer.entity'

export type ManufacturerNotificationCode =
  | GenericNotificationCode
  | 'MANUFACTURER_DELETED'
  | 'MANUFACTURER_SAVED'

export type ManufacturerModalCode = 'MANUFACTURER_DELETION'

/**
 * Parse manufacturer code to a notification
 * @param code - the manufacturer notification code
 * @returns the notification options
 */
export function parseManufacturerNotification(
  code?: ManufacturerNotificationCode,
): NotificationOptions {
  switch (code) {
    case 'MANUFACTURER_DELETED':
      return {
        message: 'Manufacturer deleted successfully',
        color: 'success',
      }
    case 'MANUFACTURER_SAVED':
      return {
        message: 'Manufacturer saved successfully',
        color: 'success',
      }
    default:
      return parseGenericNotification(code)
  }
}

/**
 * Parse manufacturer code to an modal
 * @param code - the manufacturer modal code
 * @param manufacturer - the manufacturer object
 * @returns the modal settings
 */
export function parseManufacturerModal(
  code: ManufacturerModalCode,
  manufacturer?: Manufacturer,
): DialogOptions {
  switch (code) {
    case 'MANUFACTURER_DELETION': {
      const manName = manufacturer?.name
      return {
        title: 'Delete manufacturer',
        message:
          'You are about to delete the manufacturer <strong>%s</strong>. Proceed with deletion?',
        messageParams: manName ? [manName] : undefined,
        buttons: ['Cancel', 'Confirm'],
      }
    }
    default:
      return {}
  }
}
